import styled from '@emotion/styled';

export const TagName = styled.span`
  padding: 0 5px;
  font-weight: bold;
`;

export const TagContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
